import { Fragment } from 'react';

import { SectionMessageV2 } from '@zola/zola-ui/src/components/SectionMessageV2';

import { useFormState } from 'react-final-form';

import {
  RankedDateField,
  WeddingDateFormFields,
} from '~/components/common/form/WeddingDateField/types';

import { useErrorSpy } from './useErrorSpy';

/**
 * Custom error component for the selected wedding date being booked by the vendor
 */
export const BookedDateError = ({
  field,
  forceVisible = false,
  className,
}: {
  field: undefined | RankedDateField;
  forceVisible?: boolean;
  className?: string;
}) => {
  const error = useErrorSpy('bookedDates', field);

  const message = field
    ? `This vendor isn't available then. If you're flexible and open to other dates, please add those details.`
    : `This vendor isn’t available then. If you’re flexible and open to other dates, check the box above.`;

  const { submitFailed } = useFormState<WeddingDateFormFields>();
  const showError = submitFailed || forceVisible;

  if (error && showError) {
    return (
      <SectionMessageV2 type="warning" title="Bummer" description={message} className={className} />
    );
  }
  return <Fragment />;
};
